import { sortBreakpoints } from './sortBreakpoints';
function minWidth(value, unit) {
    return "(min-width: ".concat(value).concat(unit, ")");
}
function maxWidth(value, unit) {
    return "(max-width: ".concat(value).concat(unit, ")");
}
/**
 * Creates sorted array of breakpoints sorted by descending order
 * @param breakpoints
 * @param breakpointUnit
 * @returns
 */
export function createBreakpointQueryArray(breakpoints, breakpointUnit) {
    var sortedBreakpoints = sortBreakpoints(breakpoints);
    var queryArray = sortedBreakpoints.map(function (breakpoint, breakpointIndex) {
        var smallerBreakpoint = sortedBreakpoints[breakpointIndex + 1];
        var largerBreakpoint = sortedBreakpoints[breakpointIndex - 1];
        var queries = [];
        if (smallerBreakpoint != null) {
            // larger than the current one
            queries.push(minWidth(breakpoint.width, breakpointUnit));
        }
        if (largerBreakpoint != null) {
            // smaller than the larger one
            queries.push(maxWidth(largerBreakpoint.width, breakpointUnit));
        }
        // if there is no previous and no next
        // then there is a single breakpoint that matches
        if (queries.length === 0) {
            // we need to use all, empty string fails on some browsers
            queries.push('all');
        }
        return {
            name: breakpoint.name,
            width: breakpoint.width,
            query: queries.join(' and '),
        };
    });
    return queryArray;
}
//# sourceMappingURL=createBreakpointQueryArray.js.map